<script setup lang="ts">
import { computed } from 'vue';
import { store } from '@/store';
import { platform, Bridge } from '@/common/bridge';
import vTrackClick from '@/directives/trackClick';
import BubbleIcon from './icons/BubbleIcon.vue';
import { OpenHelpEntry } from '@/common/entryLog';
import { BTN_EVTS } from '@/directives/trackClick';
import { useGetPageField } from '@/common/customisation/composables';
import { getImageFieldUrl } from '@/common/customisation/utils/imageFieldValue';
import { PUI } from '@pleased-npm/fe-customisation';
import * as SUtils from '@/common/customisation/utils/styleUtils';

const isPC = platform === 'web';

const hasNewMessage = computed(() => store.state.chat.hasNewMessage);

const containerClass = computed(() => {
  return hasNewMessage.value ? 'container__new-msg' : 'container';
});

const buttonIconField = useGetPageField({
  registryId: PUI.REGISTRY_IDS.DEFAULT_THEME,
  blockKey: PUI.THEME_BLOCK_KEYS.BRAND_ASSETS,
  sectionKey: PUI.THEME_SECTION_KEYS.CHATBOT_BUTTON_ICON,
  fieldKey: PUI.THEME_FIELD_KEYS.BUTTON_ICON,
});

const buttonIconBackgroundField = useGetPageField({
  registryId: PUI.REGISTRY_IDS.DEFAULT_THEME,
  blockKey: PUI.THEME_BLOCK_KEYS.BRAND_ASSETS,
  sectionKey: PUI.THEME_SECTION_KEYS.CHATBOT_BUTTON_ICON,
  fieldKey: PUI.THEME_FIELD_KEYS.BUTTON_ICON_BACKGROUND,
});

const buttonIconUrl = computed(() => getImageFieldUrl(buttonIconField.value));

const buttonIconBackgroundColor = computed(() => SUtils.createBackgroundStyle(buttonIconBackgroundField.value));

const openHelp = () => {
  store.commit('user/updatePageSource', OpenHelpEntry.PLEASED_FLOATING_BUTTON);
  Bridge.maximize();
};
</script>

<template>
  <div :id="isPC ? 'floatten-pc' : 'floatten-mobile'">
    <div :class="containerClass">
      <img
        v-if="buttonIconUrl"
        v-track-click="BTN_EVTS.CHATBUBBLE_OPEN"
        :src="buttonIconUrl"
        alt="Chatbot"
        class="custom-icon msg-bubble-icon"
        :style="buttonIconBackgroundColor"
        @click="openHelp"
      />
      <BubbleIcon v-else v-track-click="BTN_EVTS.CHATBUBBLE_OPEN" class="msg-bubble-icon" @click="openHelp" />
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/scss/base.scss';

#floatten-mobile {
  cursor: pointer;
  align-items: center;
  border: none;
  justify-content: center;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  z-index: 887;
  .container {
    .msg-bubble-icon {
      height: 45px;
      width: 45px;
      &.custom-icon {
        object-fit: contain;
        border-radius: 50%;
        padding: 6px;
        box-sizing: border-box;
      }
    }
  }
  .container__new-msg {
    &::before {
      background-color: $chat-bubble-new-msg-badge;
      border: 2px solid $chat-bubble-new-msg-badge;
      border-radius: 50%;
      content: '';
      height: 6px;
      position: absolute;
      right: 10px;
      top: 3px;
      width: 6px;
      z-index: 997;
    }
    .msg-bubble-icon {
      height: 45px;
      width: 45px;
      &.custom-icon {
        object-fit: contain;
        border-radius: 50%;
        padding: 6px;
        box-sizing: border-box;
      }
    }
  }
}
#floatten-pc {
  cursor: pointer;
  align-items: center;
  border: none;
  position: absolute;
  right: 0px;
  bottom: 0px;
  justify-content: center;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  z-index: 887;
  .container {
    display: flex;
    .msg-bubble-icon {
      height: 45px;
      width: 45px;
      &.custom-icon {
        object-fit: contain;
        border-radius: 50%;
        padding: 8px;
        box-sizing: border-box;
      }
    }
  }
  .container__new-msg {
    display: flex;
    &::before {
      background-color: $chat-bubble-new-msg-badge;
      border: 2px solid $chat-bubble-new-msg-badge;
      border-radius: 50%;
      content: '';
      height: 8px;
      position: absolute;
      right: 3px;
      top: 3px;
      width: 8px;
      z-index: 997;
    }
    .msg-bubble-icon {
      height: 45px;
      width: 45px;
      &.custom-icon {
        object-fit: contain;
        border-radius: 50%;
        padding: 8px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
